import React from 'react';
import { useSelector } from 'react-redux';
import { RegularButton } from 'fronton-react';
import { getHostname } from 'common/selectors';
import { analyticsUtils, patchUrlByLocale } from 'utils';
import { linkedPageItem } from './styles';
import { MAX_VISIBLE_LINKED_PAGES } from '../constants';

export type LinkedPagesItemProps = {
  pageUrl: string;
  name: string;
  isHidden: boolean;
  idx: number;
};

export const LinkedPagesItem: React.FC<LinkedPagesItemProps> = ({ pageUrl, name, isHidden, idx }) => {
  const host = useSelector(getHostname);

  const sendAnalytics = () => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'productDetail',
      elementName: 'oftenSearched',
      elementText: name,
    });
  };

  return (
    <RegularButton
      onClick={sendAnalytics}
      target="_blank"
      href={`https://${host}${patchUrlByLocale(pageUrl)}`}
      variant="outline"
      size="s"
      className={linkedPageItem}
      data-hidden={isHidden && idx + 1 > MAX_VISIBLE_LINKED_PAGES}
    >
      {name}
    </RegularButton>
  );
};
